import { FC } from 'react'
import { Card, LoaderOverlay } from '@saasalerts/ui'

export const CardLoader: FC<{
  fullPage?: boolean
  contentArea?: boolean
  withOverlay?: boolean
}> = ({ fullPage = false, contentArea = false, withOverlay = false }) => {
  return (
    <Card className="!p-24">
      <Card.Body>
        <LoaderOverlay
          fullScreen={fullPage}
          contentArea={contentArea}
          loaderProps={{ size: 'large' }}
          withOverlay={withOverlay}
        />
      </Card.Body>
    </Card>
  )
}

export default CardLoader
